module.exports = __webpack_public_path__ + "img/egali_card_image.c9bb0354.jpg";